var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto mb-2 py-2 px-2 px-sm-4 d-flex flex-column justify-space-between align-center align-md-start",attrs:{"elevation":"3"}},[_c('VoluntaryPaymentsChart'),_c('InterestRateScenario'),_c('PropertyValueAppreciationRate'),_c('DoYouWantImmediateCash'),_c('ConsiderVoluntaryPayments'),_c('SchedulePayments')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }